//
//
//
//
//
//


import setCurrentResortId from '~/mixins/pages/setCurrentResortId';
import setCurrentSeason from '~/mixins/pages/setCurrentSeason';
import setBodyClasses from '~/mixins/pages/setBodyClasses';
import validateResortRoute from '~/mixins/pages/validateResortRoute';
import { mapResortPathToId } from '~/utils/resorts';

/**
 * IFrame Page
 */
export default {
    layout: 'iframe',

    mixins: [
        setCurrentResortId,
        setCurrentSeason,
        setBodyClasses,
        validateResortRoute,
    ],

    nuxtI18n: {
        paths: {
            de: '/:season/iframe/:resort',
            en: '/:season/iframe/:resort',
            fr: '/:season/iframe/:resort',
            cn: '/:season/iframe/:resort',
        },
    },

    data() {
        return {
            resortId: mapResortPathToId(this.$route.params.resort, this.$route.params.season),
            season: this.$route.params.season,
            bodyClasses: `${this.$route.params.season}`,
        };
    },

    computed: {
        mapUrl() {
            let url = this.$getAbsoluteResortRoute(this.$store.state.currentResortId);
            if (this.$route.query.mode) {
                url = `${url}?mode=${this.$route.query.mode}`;
            }
            return url;
        },
    },

    methods: {
        openMap() {
            window.open(this.mapUrl, '_blank');
        },
    },
};
